import { CdsColorBrandNeutral70 } from '@cegid/design-tokens';
import { Typography, Link } from '@mui/material';
import TestIds from 'Tests/TestIds';
import RemoveProfileDialog from './RemoveProfileDialog';
import useTranslate from 'Hooks/useTranslate';
import { useState } from 'react';

interface Props {
  person: IPersonWithAccount;
}

const RemoveProfileLink = ({ person }: Readonly<Props>) => {
  const ts = useTranslate();

  const [removingConfirmationOpen, setRemovingConfirmationOpen] = useState(
    false
  );


  return (
    <>
      <Link
        color={CdsColorBrandNeutral70}
        component="button"
        data-testid={`${TestIds.pages.userProfile.personalInfo.deleteButton}`}
        onClick={() => setRemovingConfirmationOpen(true)}
      >
        <Typography variant="caption">
          {ts('page.userProfile.personalInformations.deleteMyProfile.button')}
        </Typography>
      </Link>
      <RemoveProfileDialog
        isOpen={removingConfirmationOpen}
        onClose={() => setRemovingConfirmationOpen(false)}
      />
    </>
  );
};

export default RemoveProfileLink;
